/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.24.4",
  "gitBuildTime": "2024-06-12T21:36:06.149Z",
  "gitBuildVersion": "1.24.4",
  "gitCommitId": "634db16",
  "gitCommitIdFull": "634db16e9327ae335e641f5fad897d54a4f2ef5a",
  "gitCommitTime": "2024-06-12T21:34:56.000Z",
  "version": "1.24.4-2024-06-12T21:34:56.000Z-(634db16)"
};
